import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { usePlaidLink } from "react-plaid-link";
import { get, post } from "../../api/";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { updateCurrentScreen } from "../../utils";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
let count = 0;
let config = {};
let linkData;
const PlaidIncomeLink = ({ type, displayAsLink, onClick, selectedIncomeType, closeModal, label, completedLoading }) => {
    const navigate = useNavigate();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [linkIVDToken, setLinkIVDToken] = useState("");
    const [linkIncomeToken, setLinkIncomeToken] = useState("");
    const [linkOtherToken, setLinkOtherToken] = useState("");
    const [linkToken, setLinkToken] = useState("");

    useEffect(() => {
        createLinkToken();
        // if (!displayAsLink) {
        //     setTimeout(() => {
        //         createLinkToken();
        //     }, 500);
        // } else {
        //     createLinkToken();
        // }
    }, []);

    const createLinkToken = async () => {
        const resultIncome = await post("plaid/create_link_token", {
            userId: userDetails?.applicant?.incomeUserId
                ? userDetails.applicant.incomeUserId
                : userDetails?.applicant?.id,
            applicantId: userDetails?.applicant?.id,
            userToken: userDetails?.applicant?.incomeUserToken,
            type: "income-verification",
            verificationType: type,
        });
        if (resultIncome.isSuccess && resultIncome.data.verificationType === type) {
            if (!displayAsLink) {
                userDetails.applicant.incomeUserId = resultIncome.data.userId;
                userDetails.applicant.incomeUserToken = resultIncome.data.userToken;
                setUserDetailsNotAsync(userDetails);
            }

            setLinkIncomeToken(resultIncome.data.data.link_token);
            setLinkToken(resultIncome.data.data.link_token);
        }
    };

    const onIncomeSuccess = async (publicToken, metadata) => {
        const result = await post("plaid/set_income_public_token", {
            userId: userDetails?.applicant?.id,
            contactId: userDetails?.applicant?.contact?.id,
            incomeUserToken: userDetails?.applicant?.incomeUserToken,
            incomeUserId: userDetails?.applicant?.incomeUserId,
            publicToken: publicToken,
            incomeType: selectedIncomeType,
        });
        if (result.isSuccess) {
            const incomeEvent = new CustomEvent("incomeEvent", {
                detail: { type: "Success", incomeUserId: userDetails.applicant.incomeUserId },
            });
            document.dispatchEvent(incomeEvent);
            // userDetails.applicant = result.data;
            userDetails.applicant.plaidIncomeVerified = true;
            setUserDetailsNotAsync(userDetails);
            closeModal();
            // window.location.reload();
        } else {
            console.log(result.errorMessage);
            const incomeEvent = new CustomEvent("incomeEvent", {
                detail: {
                    type: "Failed",
                    message: result.errorMessage,
                    incomeUserId: userDetails.applicant.incomeUserId,
                },
            });
            document.dispatchEvent(incomeEvent);
        }
    };

    const onIncomeEvent = (eventName, metadata) => {
        console.log("eventName", eventName);
        console.log("metadata", metadata);
    };

    const onIncomeExit = async (publicToken, metadata) => {
        userDetails.applicant.plaidIncomeVerified = false;
        const incomeEvent = new CustomEvent("incomeEvent", {
            detail: { type: "Exit", incomeUserId: userDetails.applicant.incomeUserId },
        });
        document.dispatchEvent(incomeEvent);
    };

    config = {
        token: linkIncomeToken,
        onSuccess: onIncomeSuccess,
        onEvent: onIncomeEvent,
        onExit: onIncomeExit,
    };

    linkData = usePlaidLink(config);
    // const {open, ready} = usePlaidLink(config)

    const handleOnClick = () => {
        // onClick();
        console.log(config, linkData?.error, linkData?.open, linkData?.ready, linkIncomeToken, linkToken, userDetails);
        // if(linkData.ready) linkData.open();
        linkData.open();
    };

    useEffect(() => {
        if (linkToken && linkData?.ready) {
            if (completedLoading) {
                completedLoading();
            }
        }
    }, [linkData?.ready, linkToken]);

    return (
        <>
            {!displayAsLink && (
                <Button
                    color="primary"
                    fullWidth
                    variant="contained"
                    sx={{
                        height: "45px",
                        backgroundColor: "#0D2D3A",
                    }}
                    onClick={() => handleOnClick()}
                    disabled={linkToken && linkData?.ready ? false : true}>
                    <AddCircleOutlineOutlinedIcon sx={{ mr: "10px" }} color="white" />
                    {label ? label : "Add income from Plaid"}
                </Button>
            )}
            {displayAsLink && (
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{ mt: 1, mb: 1, cursor: "pointer" }}
                    onClick={() => handleOnClick()}
                    disabled={linkToken && linkData?.ready ? false : true}>
                    <AddCircleOutlineOutlinedIcon color="primary" />
                    <Typography
                        variant="h6"
                        display="block"
                        gutterBottom
                        sx={{
                            textTransform: "none",
                            display: "flex",
                            alignItems: "center",
                            color: "#06aed4",
                        }}>
                        <b>Add with Plaid!</b>
                    </Typography>
                </Stack>
            )}
        </>
    );
};

export { PlaidIncomeLink };
